module.exports = __webpack_public_path__ + "static/media/integrated_payment.207d6452.svg";